import { useWebWorkerFn } from '@vueuse/core';

import type { TransactionGroup } from '@/composables/useTransactionsView.types';

export function useTransactionsViewFilterer() {
  const {
    workerFn: filterGroups,
    workerStatus: filtererStatus,
    workerTerminate: filtererTerminate
  } = useWebWorkerFn((groups: TransactionGroup[], searchValue: string): TransactionGroup[] => {
    const searchValueTrimmed = searchValue.trim().toLowerCase();

    if (searchValueTrimmed === '') {
      return groups;
    }

    return groups.reduce((acc, group) => {
      const filteredTransactions = group.items.filter((item) =>
        item.title.includes(searchValueTrimmed)
      );
      if (filteredTransactions.length === 0) {
        return acc;
      }

      return acc.concat({
        title: group.title,
        id: group.id,
        items: filteredTransactions
      });
    }, new Array<TransactionGroup>());
  });

  return { filterGroups, filtererTerminate, filtererStatus };
}
